import React from 'react';
import './SegmentedControl.css';

/**
 * Universal Apple-style Segment-Steuerung.
 * 
 * @component SegmentedControl
 * @param {Object} props
 * @param {Array} props.options - Array von `{ value: string, label: string }`.
 * @param {string} props.value - Aktuell ausgewähltes Segment.
 * @param {Function} props.onChange - Callback bei Segmentänderung.
 * @param {boolean} [props.disabled] - Deaktiviert-Status.
 */
export default function SegmentedControl({ options = [], value, onChange, disabled }) {
    return (
        <div className={`co-segmented-control ${disabled ? 'disabled' : ''}`}>
            {options.map((opt) => {
                const isActive = opt.value === value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        className={`co-segmented-item ${isActive ? 'active' : ''}`}
                        onClick={() => !disabled && onChange && onChange(opt.value)}
                        disabled={disabled}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}
